module.exports = __webpack_public_path__ + "img/icon-adstxt.08042243.png";